










































import Vue from "vue";
import handleCanvas from "@/mixin/handleCanvas";
export default Vue.extend({
  mixins: [handleCanvas],
  props: {
    label: String,
    type: String,
    items: [],
  },
});
